import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuTrash2, LuPlus } from 'react-icons/lu';
import api from '../../../services/api';
import DateInput from '../../ui/DateInput';
import { getTodayISO } from '../../../utils/dateUtils';

// Repuestos que compraste para la empresa y no están cargados en un trabajo (22-oct-2026).
// Precio que pagaste por unidad, IVA incluido: se suma al cierre del período en que se compró.

const fmt = v => `$ ${Math.round(Number(v || 0)).toLocaleString('es-AR')}`;
const fmtFecha = f => { const [a, m, d] = String(f).slice(0, 10).split('-'); return `${d}/${m}/${a.slice(2)}`; };
// "14592,60", "14.592,60", "14592.60" y "14.592" (miles) → 14592.6 / 14592. Antes "14592.60" se
// tomaba como 1.459.260 (22-oct-2026).
export function aNumero(v) {
    const t = String(v || '').trim().replace(/\s|\$/g, '');
    if (t.includes(',')) return t.replace(/\./g, '').replace(',', '.');
    const partes = t.split('.');
    if (partes.length > 2 || (partes.length === 2 && partes[1].length === 3)) return partes.join('');
    return t;
}
const INPUT = 'h-10 px-3 rounded-xl bg-panel text-ink text-caption font-bold outline-none placeholder:text-muted placeholder:font-medium';

export default function RepuestosComprados({ clienteId, lista, onCambio }) {
    const [abierto, setAbierto] = useState(false);
    const [nuevo, setNuevo] = useState({ fecha: getTodayISO(), detalle: '', cantidad: '1', precio: '' });
    const [guardando, setGuardando] = useState(false);

    const agregar = async () => {
        setGuardando(true);
        try {
            await api.post(`/clientes/${clienteId}/cierre-mensual/repuestos`, {
                ...nuevo, precio: aNumero(nuevo.precio), cantidad: aNumero(nuevo.cantidad),
            });
            setNuevo(n => ({ ...n, detalle: '', cantidad: '1', precio: '' }));
            onCambio();
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo agregar'); }
        finally { setGuardando(false); }
    };
    const quitar = async (id) => {
        try { await api.delete(`/clientes/${clienteId}/cierre-mensual/repuestos`, { params: { id } }); onCambio(); }
        catch { toast.error('No se pudo quitar'); }
    };

    return (
        <div className="space-y-1.5">
            {lista.map(r => (
                <div key={r.id} className="flex items-center gap-2 px-3 py-2 rounded-xl bg-panel">
                    <div className="flex-1 min-w-0">
                        <p className="text-caption font-bold text-ink truncate">{Number(r.cantidad)} × {r.detalle}</p>
                        <p className="text-label text-muted">{fmtFecha(r.fecha)} · {fmt(r.precio)} c/u</p>
                    </div>
                    <p className="shrink-0 text-caption font-black text-ink">{fmt(r.subtotal)}</p>
                    <button type="button" onClick={() => quitar(r.id)} aria-label="Quitar" className="w-8 h-8 shrink-0 rounded-lg bg-chip text-muted flex items-center justify-center active:scale-95"><LuTrash2 size={13} /></button>
                </div>
            ))}
            {abierto ? (
                <div className="p-3 rounded-xl bg-chip space-y-2">
                    <input value={nuevo.detalle} onChange={e => setNuevo(n => ({ ...n, detalle: e.target.value }))} placeholder="Qué compraste (ej. canilla agua fría)" className={INPUT + ' w-full'} autoFocus />
                    <div className="grid grid-cols-[1fr_4.5rem_6.5rem] gap-1.5">
                        <DateInput value={nuevo.fecha} onChange={v => setNuevo(n => ({ ...n, fecha: v }))} className={INPUT + ' min-w-0'} />
                        <input value={nuevo.cantidad} onChange={e => setNuevo(n => ({ ...n, cantidad: e.target.value }))} inputMode="decimal" placeholder="Cant." className={INPUT + ' min-w-0'} />
                        <input value={nuevo.precio} onChange={e => setNuevo(n => ({ ...n, precio: e.target.value }))} inputMode="decimal" placeholder="$ c/u" className={INPUT + ' min-w-0'} />
                    </div>
                    <p className="text-label text-muted">Lo que pagaste por unidad, con IVA incluido.</p>
                    <div className="flex gap-2">
                        <button type="button" onClick={() => setAbierto(false)} className="h-10 px-3 rounded-xl text-label font-black text-secondary">Listo</button>
                        <button type="button" onClick={agregar} disabled={guardando || !nuevo.detalle.trim() || !nuevo.precio}
                            className="flex-1 h-10 rounded-xl bg-ink text-page text-label font-black active:scale-95 disabled:opacity-40">{guardando ? 'Agregando…' : 'Agregar'}</button>
                    </div>
                </div>
            ) : (
                <button type="button" onClick={() => setAbierto(true)} className="w-full h-10 rounded-xl border border-dashed border-black/15 dark:border-white/15 text-label font-black text-secondary flex items-center justify-center gap-1.5 active:scale-95">
                    <LuPlus size={14} /> Agregar repuesto comprado
                </button>
            )}
        </div>
    );
}
